<template>
  <v-container fluid fill-height pa-0 class="white">

    <v-layout align-center justify-center>

      <div class="red">

        <div class="blue">
          {{ getMessage }}
        </div>

      </div>

    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: "REPORTS",

  components: {},

  computed: {
    getMessage(){
      return this.message
    },
  },

  data: () => ({

    message: 'REPORTS'

  }),

  watch: {},

  created () {},

  mounted () {},

  methods: {

    setup: function () {
      
    },
  },
}

</script>

<style>

</style>
